import { api } from './api'

// Admin "entra" no perfil de um usuário (Configurações → Usuários), em modo
// visualização (só leitura) ou edição. Faz backup da sessão do admin pra poder voltar.
export async function entrarComoUsuario(uid: number, modo: 'visualizacao' | 'edicao') {
  const { data } = await api.post(`/auth/usuarios/${uid}/impersonar`, { modo })
  // Backup do admin atual (só na 1ª vez — impersonação não aninha)
  if (!localStorage.getItem('pain_impersonator')) {
    localStorage.setItem('pain_impersonator', JSON.stringify({
      token: localStorage.getItem('pain_token'),
      user: localStorage.getItem('pain_user'),
      empresa: localStorage.getItem('pain_empresa'),
      filial: localStorage.getItem('pain_filial_atual'),
      consolidado: localStorage.getItem('pain_modo_consolidado'),
    }))
  }
  localStorage.setItem('pain_token', data.access_token)
  localStorage.setItem('pain_user', JSON.stringify(data.usuario))
  if (data.empresa) localStorage.setItem('pain_empresa', JSON.stringify(data.empresa))
  localStorage.setItem('pain_imp', JSON.stringify({ nome: data.usuario.nome, modo: data.modo }))
  localStorage.removeItem('velore_readonly')  // não herda o toggle do admin
  // MANTÉM a filial que o admin está vendo (ex.: VOW BIKES) e só desliga o
  // consolidado — assim o X-Filial-Id continua sendo enviado e as listas por
  // filial (ex.: vendedores no PDV) ficam restritas à filial atual. Não resetar:
  // o usuário-alvo costuma não ter vínculo → /filiais/minha cairia na matriz.
  localStorage.setItem('pain_modo_consolidado', 'false')
  window.location.href = '/'  // recarrega já como o usuário
}

// Volta pra sessão original do admin.
export function sairImpersonacao() {
  const bak = localStorage.getItem('pain_impersonator')
  if (bak) {
    try {
      const b = JSON.parse(bak)
      if (b.token) localStorage.setItem('pain_token', b.token)
      if (b.user) localStorage.setItem('pain_user', b.user)
      else localStorage.removeItem('pain_user')
      if (b.empresa) localStorage.setItem('pain_empresa', b.empresa)
      else localStorage.removeItem('pain_empresa')
      // Restaura o contexto de filial do admin
      if (b.filial) localStorage.setItem('pain_filial_atual', b.filial)
      else localStorage.removeItem('pain_filial_atual')
      localStorage.setItem('pain_modo_consolidado', b.consolidado === 'true' ? 'true' : 'false')
    } catch {}
  }
  localStorage.removeItem('pain_impersonator')
  localStorage.removeItem('pain_imp')
  window.location.href = '/'
}
